<template>
  <div class="couponDiv">
    <header class="pageHeader">
      <div class="hBtnl">
        <button class="btnDiv btnDivd btnDivn">
          <i class="iconfont">&#xe601;</i>
        </button>
      </div>
      <h1 class="pageHeader-title">已过期优惠券</h1>
      <div class="hBtnr">
        <button class="btnDiv btnDivd btnDivn">
          <!---->
          <label class="btnDiv-text"></label>
        </button>
      </div>
    </header>
    <!-- <div class="noData show"><p>暂无相关信息</p></div> -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="conList">
        <div class="conDiv">
          <div class="item">
            <div class="con1">
              <div class="weight">100元</div>
              <div>满200元可用</div>
            </div>
            <div class="con2">
              <div>仅纪念堂可用</div>
              <div>2022.02.01~2022.02.30</div>
              <div class="btn">不可用</div>
            </div>
          </div>
          <div class="item">
            <div class="con1">
              <div class="weight">100元</div>
              <div>满200元可用</div>
            </div>
            <div class="con2">
              <div>仅纪念堂可用</div>
              <div>2022.02.01~2022.02.30</div>
              <div class="btn">不可用</div>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <div class="footer">
      <span>领取优惠券</span>
      <div class="line"></div>
      <span @click="goto('/shop/mycoupon')">可用优惠券</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'coupon',
  data() {
    return {
      couponPage: 1,
      couponList: [],
      isLoading: false,
    }
  },
  created() {},
  methods: {
    queryCouponPage() {
      var that = this
      this.$queryPage(
        '/api/coupon/queryMyCouponByExpire',
        {myId: this.$store.getters.userId,page:this.couponPage, sort:{createDate:0}},
        function(res) {
          that.isLoading = false
          if(res.data.length>0){
            that.$fill(that.couponList, res.data)
            that.couponPage ++
          }
        }
      )
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        this.queryCouponPage()
      }, 1000)
    },
    goto(str) {
      this.$router.push({ path: str })
    },
  },
  mounted(){
    this.queryCouponPage()
  }
}
</script>

<style>
.couponDiv .conList {
  padding: 0 1.2rem;
}
.couponDiv .conDiv {
}
.couponDiv .weight {
  font-weight: bold;
  font-size: 1.8rem;
}
.couponDiv .con1 {
  background: #dea767;
  width: 12rem;
  height: 8rem;
  border-radius: 5px;
  color: #fff;
  padding: 1rem;
  line-height: 3rem;
  text-align: center;
}
.couponDiv .con2 {
  padding: 1rem;
  line-height: 2rem;
}
.couponDiv .con2 .btn {
  color: #dea767;
}
.couponDiv .item {
  display: flex;
  margin-top: 2rem;
  background: #fff;
}
.couponDiv .pageHeader {
  background-color: #fff;
  color: #333;
  -ms-flex-align: center;
  align-items: center;

  box-sizing: border-box;

  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  height: 40px;
  line-height: 1;
  padding: 0 10px;
  position: relative;
  text-align: center;
  white-space: nowrap;
}

.couponDiv .hBtnl {
  -ms-flex: 0.5;
  flex: 0.5;
  text-align: left;
}
.couponDiv .hBtnr {
  -ms-flex: 0.5;
  flex: 0.5;
  text-align: right;
}
.couponDiv .pageHeader .pageHeader-title {
  font-size: 18px;
}
.couponDiv .pageHeader-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: inherit;
  font-weight: 400;
  -ms-flex: 1;
  flex: 1;
}

.couponDiv .hBtn {
  -ms-flex: 0.5;
  flex: 0.5;
}
.couponDiv .pageHeader .btnDiv {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  color: inherit;
  display: inline-block;
  padding: 0;
  font-size: inherit;
}
.couponDiv .btnDivn,
.couponDiv .btnDivs {
  display: inline-block;
  padding: 0 12px;
}
.couponDiv .btnDivd {
  color: #656b79;
  background-color: #f6f8fa;
  box-shadow: 0 0 1px #b8bbbf;
}
.couponDiv .noData {
  display: none;
  width: 12rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.couponDiv .show {
  display: block !important;
}
.couponDiv .noData:before {
  width: 100%;
  height: 9.5rem;
  display: block;
  content: '';
  background: url(../../../assets/noData.png) 50% no-repeat;
  background-size: contain;
}

.couponDiv .noData p {
  font-size: 1.4rem;
  color: #999;
  text-align: center;
  height: 2.4rem;
  line-height: 2.4rem;
  margin-top: 1.4rem;
}
.couponDiv .orderinfo {
  padding: 1.5rem;
}
.couponDiv .clear-foot {
  clear: both;
  height: 5rem;
}
.couponDiv .footer {
  background-color: #fff;
  color: #000;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 5.5rem;
  line-height: 5.5rem;
}
.couponDiv .footer span {
  display: inline-block;
  width: 50%;
  float: left;
  text-align: center;
  font-size: 1.5rem;
}
.couponDiv .footer .line {
  position: absolute;
  left: 50%;
  top: 2rem;
  height: 2rem;
  border: 1px solid #b1b1b1;
}
.couponDiv .footer span {
  display: inline-block;
  width: 50%;
  float: left;
  text-align: center;
  font-size: 1.5rem;
}
</style>
